<template>
  <div class="cg-page container-fluid p-4 pt-5 pb-5">
    <div class="cg-inner">
      <LoadingIndicatorComponent v-if="!loaded" />
      <AccessLocked v-else-if="!enabled" />
      <RouterView v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingIndicatorComponent from "@/components/common/LoadingIndicatorComponent.vue";
import { RouterView } from "vue-router";
import AccessLocked from "./components/AccessLocked.vue";
import { useComplianceAccess } from "./useComplianceAccess";

// Route parent for every demo screen: gates on the account flag and loads the shared .cg-* styles.
const { loaded, enabled } = useComplianceAccess();
</script>

<style lang="scss">
@use "./complianceGroups";
</style>

<style scoped lang="scss">
// The dashboard wrapper paints the sidenav colour behind routed content; every user-facing page
// supplies its own light panel (same treatment as EcolabelsView).
.cg-page {
  background-color: var(--phoenix-body-bg);
  border-radius: 1rem 1rem 0 0;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}
</style>
